<template>
    <div class="properties-visible-editor">
        <header class="header">
            <span>Edit Attribute Columns</span>
            <!--            <button class="button-reset pure button-with-icon" @click="reset" v-if="hasUncheckedItems"><i class="gf gf-reset"></i> Reset</button>-->
        </header>
        <div class="body">
            <div><label><input type="checkbox" ref="allCheckbox" @change="onAllCheckboxChange"> All Attributes</label>
            </div>
            <hr>
            <div class="checkboxes" @change="onCheckboxesChange">
                <div v-for="(item,index) in attributeProperties" :key="index"><label><input type="checkbox"
                                                                                            ref="checkboxes">
                    <span>{{ item.fullLabel }}</span></label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PropertiesVisibleEditor",
    props: {
        attributeProperties: Array,
    },
    methods: {
        fillValue(hiddenMaps) {
            const refCheckboxes = this.$refs.checkboxes;
            const {attributeProperties} = this;
            refCheckboxes.forEach((v, i) => {
                refCheckboxes[i].checked = !(hiddenMaps[attributeProperties[i].propertyKey]);
            });
            this.validateUncheckedItems();
        },
        onCheckboxesChange(event) {
            const refCheckboxes = this.$refs.checkboxes;
            const {attributeProperties} = this;

            const target = event.target;
            const indexOfTarget = refCheckboxes.indexOf(target);

            this.validateUncheckedItems();
            this.$emit('updateHiddenMaps', {
                propertyKey: attributeProperties[indexOfTarget].propertyKey,
                hidden: !target.checked
            });
        },
        validateUncheckedItems() {
            const refCheckboxes = this.$refs.checkboxes;
            let i = 0, len = refCheckboxes.length;
            let hasUncheckedItems = false;
            for (; i < len; i++) {
                if (!refCheckboxes[i].checked) {
                    hasUncheckedItems = true;
                    break;
                }
            }
            this.hasUncheckedItems = hasUncheckedItems;
            this.$refs.allCheckbox.checked = !this.hasUncheckedItems;
        },
        reset() {
            const refCheckboxes = this.$refs.checkboxes;
            refCheckboxes.forEach(v => {
                v.checked = true;
            });
            this.hasUncheckedItems = false;
            this.$emit('resetHiddenMaps');
        },
        hideAll() {
            const refCheckboxes = this.$refs.checkboxes;
            refCheckboxes.forEach(v => {
                v.checked = false;
            });
            this.hasUncheckedItems = true;
            this.$emit('fillHiddenMaps');
        },
        onAllCheckboxChange(event) {
            if (event.target.checked) {
                this.reset();
            } else {
                this.hideAll();
            }
        },
    },
    data() {
        return {
            hasUncheckedItems: false,
        }
    }
}
</script>

<style scoped lang="scss">
.properties-visible-editor {
    padding: 0.25rem 0;
    min-width: 200px;

    .header {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.6rem;
        width: 100%;
        padding: 0 0.8rem;

        span {
            font-weight: 500;
        }
    }
}

hr {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}

.body {
    label {
        padding: 0.15rem 0.8rem;
        margin-bottom: 0.15rem;
        display: flex;
        align-items: center;

        &:hover {
            background-color: rgba(black, 0.06);
        }

        input {
            margin-right: 0.25rem;
        }

        span {
            display: inline-block;
            max-width: 320px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

footer {
    font-weight: 300;
    text-align: center;
    padding: 0.5rem 0;
    color: gray;
}
</style>
